/*********************************************************************
 *
 * WARNING: This shader manager class is automatically generated, any manual
 * edits will be lost.
 *
********************************************************************/
import { ShaderManagerBase } from '../shader-manager-base';
import { VolumetricShader, VolumetricShaderSettings } from './VolumetricShader.generated';
import { TaaShader, TaaShaderSettings } from './TaaShader.generated';
import { SsaoBlurCrossShader, SsaoBlurCrossShaderSettings } from './SsaoBlurCrossShader.generated';
import { SsaoBlurShader, SsaoBlurShaderSettings } from './SsaoBlurShader.generated';
import { SsaoShader, SsaoShaderSettings } from './SsaoShader.generated';
import { SkyBoxShader, SkyBoxShaderSettings } from './SkyBoxShader.generated';
import { ProceduralSkyShader, ProceduralSkyShaderSettings } from './ProceduralSkyShader.generated';
import { PickingShader, PickingShaderSettings } from './PickingShader.generated';
import { OverlayShader, OverlayShaderSettings } from './OverlayShader.generated';
import { LiquidSurfaceShader, LiquidSurfaceShaderSettings } from './LiquidSurfaceShader.generated';
import { GodRaysOcclusionShader, GodRaysOcclusionShaderSettings } from './GodRaysOcclusionShader.generated';
import { GodRaysBlurShader, GodRaysBlurShaderSettings } from './GodRaysBlurShader.generated';
import { GBufferTerrainShader, GBufferTerrainShaderSettings } from './GBufferTerrainShader.generated';
import { GBufferShader, GBufferShaderSettings } from './GBufferShader.generated';
import { FxaaShader, FxaaShaderSettings } from './FxaaShader.generated';
import { FullscreenCompositeShader, FullscreenCompositeShaderSettings } from './FullscreenCompositeShader.generated';
import { ForwardTransparentShader, ForwardTransparentShaderSettings } from './ForwardTransparentShader.generated';
import { FlameShader, FlameShaderSettings } from './FlameShader.generated';
import { FinalPresentShader, FinalPresentShaderSettings } from './FinalPresentShader.generated';
import { TestGeometryShader, TestGeometryShaderSettings } from './TestGeometryShader.generated';
import { SkinnedDebugShader, SkinnedDebugShaderSettings } from './SkinnedDebugShader.generated';
import { DepthShader, DepthShaderSettings } from './DepthShader.generated';
import { DeferredLightShader, DeferredLightShaderSettings } from './DeferredLightShader.generated';
import { DecalShader, DecalShaderSettings } from './DecalShader.generated';
import { CsmMomentsResolveShader, CsmMomentsResolveShaderSettings } from './CsmMomentsResolveShader.generated';
import { CsmMomentsBlurShader, CsmMomentsBlurShaderSettings } from './CsmMomentsBlurShader.generated';
import { CsmMomentsBlendShader, CsmMomentsBlendShaderSettings } from './CsmMomentsBlendShader.generated';
import { CloudVolumesShader, CloudVolumesShaderSettings } from './CloudVolumesShader.generated';
import { BloomShader, BloomShaderSettings } from './BloomShader.generated';
import { AerialPerspectiveShader, AerialPerspectiveShaderSettings } from './AerialPerspectiveShader.generated';


export class ShaderManager extends ShaderManagerBase {

   public getVolumetricShader(...settings: VolumetricShaderSettings) : VolumetricShader {
        return super.getShader('VolumetricShader', settings, () => new VolumetricShader(this.ctx, settings)) as VolumetricShader;
    }
   public getTaaShader(...settings: TaaShaderSettings) : TaaShader {
        return super.getShader('TaaShader', settings, () => new TaaShader(this.ctx, settings)) as TaaShader;
    }
   public getSsaoBlurCrossShader(...settings: SsaoBlurCrossShaderSettings) : SsaoBlurCrossShader {
        return super.getShader('SsaoBlurCrossShader', settings, () => new SsaoBlurCrossShader(this.ctx, settings)) as SsaoBlurCrossShader;
    }
   public getSsaoBlurShader(...settings: SsaoBlurShaderSettings) : SsaoBlurShader {
        return super.getShader('SsaoBlurShader', settings, () => new SsaoBlurShader(this.ctx, settings)) as SsaoBlurShader;
    }
   public getSsaoShader(...settings: SsaoShaderSettings) : SsaoShader {
        return super.getShader('SsaoShader', settings, () => new SsaoShader(this.ctx, settings)) as SsaoShader;
    }
   public getSkyBoxShader(...settings: SkyBoxShaderSettings) : SkyBoxShader {
        return super.getShader('SkyBoxShader', settings, () => new SkyBoxShader(this.ctx, settings)) as SkyBoxShader;
    }
   public getProceduralSkyShader(...settings: ProceduralSkyShaderSettings) : ProceduralSkyShader {
        return super.getShader('ProceduralSkyShader', settings, () => new ProceduralSkyShader(this.ctx, settings)) as ProceduralSkyShader;
    }
   public getPickingShader(...settings: PickingShaderSettings) : PickingShader {
        return super.getShader('PickingShader', settings, () => new PickingShader(this.ctx, settings)) as PickingShader;
    }
   public getOverlayShader(...settings: OverlayShaderSettings) : OverlayShader {
        return super.getShader('OverlayShader', settings, () => new OverlayShader(this.ctx, settings)) as OverlayShader;
    }
   public getLiquidSurfaceShader(...settings: LiquidSurfaceShaderSettings) : LiquidSurfaceShader {
        return super.getShader('LiquidSurfaceShader', settings, () => new LiquidSurfaceShader(this.ctx, settings)) as LiquidSurfaceShader;
    }
   public getGodRaysOcclusionShader(...settings: GodRaysOcclusionShaderSettings) : GodRaysOcclusionShader {
        return super.getShader('GodRaysOcclusionShader', settings, () => new GodRaysOcclusionShader(this.ctx, settings)) as GodRaysOcclusionShader;
    }
   public getGodRaysBlurShader(...settings: GodRaysBlurShaderSettings) : GodRaysBlurShader {
        return super.getShader('GodRaysBlurShader', settings, () => new GodRaysBlurShader(this.ctx, settings)) as GodRaysBlurShader;
    }
   public getGBufferTerrainShader(...settings: GBufferTerrainShaderSettings) : GBufferTerrainShader {
        return super.getShader('GBufferTerrainShader', settings, () => new GBufferTerrainShader(this.ctx, settings)) as GBufferTerrainShader;
    }
   public getGBufferShader(...settings: GBufferShaderSettings) : GBufferShader {
        return super.getShader('GBufferShader', settings, () => new GBufferShader(this.ctx, settings)) as GBufferShader;
    }
   public getFxaaShader(...settings: FxaaShaderSettings) : FxaaShader {
        return super.getShader('FxaaShader', settings, () => new FxaaShader(this.ctx, settings)) as FxaaShader;
    }
   public getFullscreenCompositeShader(...settings: FullscreenCompositeShaderSettings) : FullscreenCompositeShader {
        return super.getShader('FullscreenCompositeShader', settings, () => new FullscreenCompositeShader(this.ctx, settings)) as FullscreenCompositeShader;
    }
   public getForwardTransparentShader(...settings: ForwardTransparentShaderSettings) : ForwardTransparentShader {
        return super.getShader('ForwardTransparentShader', settings, () => new ForwardTransparentShader(this.ctx, settings)) as ForwardTransparentShader;
    }
   public getFlameShader(...settings: FlameShaderSettings) : FlameShader {
        return super.getShader('FlameShader', settings, () => new FlameShader(this.ctx, settings)) as FlameShader;
    }
   public getFinalPresentShader(...settings: FinalPresentShaderSettings) : FinalPresentShader {
        return super.getShader('FinalPresentShader', settings, () => new FinalPresentShader(this.ctx, settings)) as FinalPresentShader;
    }
   public getTestGeometryShader(...settings: TestGeometryShaderSettings) : TestGeometryShader {
        return super.getShader('TestGeometryShader', settings, () => new TestGeometryShader(this.ctx, settings)) as TestGeometryShader;
    }
   public getSkinnedDebugShader(...settings: SkinnedDebugShaderSettings) : SkinnedDebugShader {
        return super.getShader('SkinnedDebugShader', settings, () => new SkinnedDebugShader(this.ctx, settings)) as SkinnedDebugShader;
    }
   public getDepthShader(...settings: DepthShaderSettings) : DepthShader {
        return super.getShader('DepthShader', settings, () => new DepthShader(this.ctx, settings)) as DepthShader;
    }
   public getDeferredLightShader(...settings: DeferredLightShaderSettings) : DeferredLightShader {
        return super.getShader('DeferredLightShader', settings, () => new DeferredLightShader(this.ctx, settings)) as DeferredLightShader;
    }
   public getDecalShader(...settings: DecalShaderSettings) : DecalShader {
        return super.getShader('DecalShader', settings, () => new DecalShader(this.ctx, settings)) as DecalShader;
    }
   public getCsmMomentsResolveShader(...settings: CsmMomentsResolveShaderSettings) : CsmMomentsResolveShader {
        return super.getShader('CsmMomentsResolveShader', settings, () => new CsmMomentsResolveShader(this.ctx, settings)) as CsmMomentsResolveShader;
    }
   public getCsmMomentsBlurShader(...settings: CsmMomentsBlurShaderSettings) : CsmMomentsBlurShader {
        return super.getShader('CsmMomentsBlurShader', settings, () => new CsmMomentsBlurShader(this.ctx, settings)) as CsmMomentsBlurShader;
    }
   public getCsmMomentsBlendShader(...settings: CsmMomentsBlendShaderSettings) : CsmMomentsBlendShader {
        return super.getShader('CsmMomentsBlendShader', settings, () => new CsmMomentsBlendShader(this.ctx, settings)) as CsmMomentsBlendShader;
    }
   public getCloudVolumesShader(...settings: CloudVolumesShaderSettings) : CloudVolumesShader {
        return super.getShader('CloudVolumesShader', settings, () => new CloudVolumesShader(this.ctx, settings)) as CloudVolumesShader;
    }
   public getBloomShader(...settings: BloomShaderSettings) : BloomShader {
        return super.getShader('BloomShader', settings, () => new BloomShader(this.ctx, settings)) as BloomShader;
    }
   public getAerialPerspectiveShader(...settings: AerialPerspectiveShaderSettings) : AerialPerspectiveShader {
        return super.getShader('AerialPerspectiveShader', settings, () => new AerialPerspectiveShader(this.ctx, settings)) as AerialPerspectiveShader;
    }

}
